import React from 'react'


import './Home.css'

export default function Home() {
  return (
    <div className='row' id='wrapper'>
        <div id='text_id' className='col-12 d-flex align-items-center justify-content-center'>
            <h1 className='text-center'>Welcome</h1>
        </div>
    </div>
  )
}
